import { render } from "./Signup.vue?vue&type=template&id=b94fea2e"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__